export default [
  { id: 'local', text: 'Local' },
  { id: 'national', text: 'National' }
];



// WEBPACK FOOTER //
// ./src/data/service-areas.js